import { render, staticRenderFns } from "./IdActiveView.vue?vue&type=template&id=4dc99e99&scoped=true"
import script from "./IdActiveView.vue?vue&type=script&lang=js"
export * from "./IdActiveView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc99e99",
  null
  
)

export default component.exports